import React from "react";

/**
 * ButtonGroup Molecule - Group of related buttons
 * Used for action groups, toolbars, and related controls
 * 
 * @component
 * @example
 * <ButtonGroup>
 *   <Button>Left</Button>
 *   <Button>Middle</Button>
 *   <Button>Right</Button>
 * </ButtonGroup>
 */
const ButtonGroup = ({
  children,
  orientation = "horizontal",
  spacing = "none",
  className = "",
  ...props
}) => {

  const orientationStyles = {
    horizontal: "flex-row",
    vertical: "flex-col",
  };

  const spacingStyles = {
    none: "gap-0",
    xs: "gap-1",
    sm: "gap-2",
    md: "gap-3",
    lg: "gap-4",
  };

  const groupClasses = `
    inline-flex
    ${orientationStyles[orientation] || orientationStyles.horizontal}
    ${spacingStyles[spacing] || spacingStyles.none}
    ${className}
  `.replace(/\s+/g, ' ').trim();

  return (
    <div className={groupClasses} role="group" {...props}>
      {children}
    </div>
  );
};

ButtonGroup.displayName = "ButtonGroup";

export default ButtonGroup;
